import React, { createContext, PropsWithChildren, useContext } from 'react';
import { AccountInfoResult } from '@block-explorer/entities';
import { useCreateAccountsInfoGetter } from '../hooks';

export const accountDataContext = createContext<{
  getAccountInfo: <T>(publicKey: string) => T | null | undefined;
  getPublicKeyAccountHash: (accountHash: string) => string | null | undefined;
  getAccountInfoByHash?: (
    publicKey: string
  ) => AccountInfoResult | null | undefined;
}>({ getAccountInfo: () => null, getPublicKeyAccountHash: () => null });

const { Provider: AccountDataContextProvider } = accountDataContext;

export const useAccountInfoContext = () => {
  return useContext(accountDataContext);
};

interface AccountDataContextProviderProps {
  accountHashes: string[];
}
export const AccountDataProvider = (
  props: PropsWithChildren<AccountDataContextProviderProps>
) => {
  const { accountHashes } = props;

  const {
    getAccountInfo,
    getAccountInfoByHash,
    getPublicKeyAccountHash,
    loading: loadingAccountsInfo,
  } = useCreateAccountsInfoGetter(accountHashes);

  return (
    <AccountDataContextProvider
      value={{ getAccountInfo, getAccountInfoByHash, getPublicKeyAccountHash }}
      {...props}
    />
  );
};
